import type { Material, MaterialCategory } from '../../types';
import { CONSTANTS } from '../../data.js';

const categoryOrder: Record<MaterialCategory, number> = {
  basic: 0,
  component: 1,
  advanced: 2,
  robot: 3,
  custom: 4,
};

export function computeDiscoveredSorted(inventory: Material[]): Material[] {
  return inventory
    .filter(item => item.discovered)
    // Filter to only show base ingredients in the sidebar
    .filter(item => CONSTANTS.BASE_INGREDIENTS.includes(item.id))
    .sort((a, b) => {
      const aOrder = categoryOrder[a.category] ?? 99;
      const bOrder = categoryOrder[b.category] ?? 99;
      if (aOrder !== bOrder) return aOrder - bOrder;
      return a.name.localeCompare(b.name);
    });
}

export function filterBySearch(items: Material[], query: string): Material[] {
  if (!query) return items;
  const q = query.toLowerCase();
  return items.filter(item => item.name.toLowerCase().includes(q));
}
